import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { canAccessForceCompleteWorkflow } from './force-complete-access';
import { UserContextService } from './user-context.service';

/** Доступ: глобальный админ или модератор хотя бы одной БФ. */
export const AdminOrModeratorGuardService: CanActivateFn = () => {
  const userContextSvc = inject(UserContextService);
  const router = inject(Router);
  return userContextSvc.getUserContext().pipe(
    map((user) => {
      if (canAccessForceCompleteWorkflow(user)) {
        return true;
      }
      router.navigate(['/welcome']);
      return false;
    })
  );
};
